import { alpha, Box, Card, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { capturePHEvents } from '../../../analytics/posthog.analytics';
import Image from '../../../fl-components/Image';
import { API_LIMIT_DATA, searchFilter } from '../../../utils/constants';
import { searchClasses } from '../../../service/discoverSearch.service';
import { ADD_DISCOVER_DATA } from '../../../redux/constants';
import { PH_DISCOVER_CATEGORY_CLICK } from '../../../utils/posthog.eventNames';

function DisplayCategory({ title, list, filterData }) {
  const imageColors = ['#826AF9', '#2D99FF', '#2CD9C5', '#FFE700', '#FF6C40'];

  return (
    <Box mb={5}>
      <Typography mb={2} sx={{ color: 'text.secondary' }} fontWeight="600" fontSize={18}>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {list.map((l, key) => (
          <Grid key={key} item xs={6} sm={3} md={3}>
            <Card
              sx={{
                textAlign: 'center',
                py: 3,
                borderRadius: 1,
                position: 'relative',
                cursor: 'pointer'
              }}
              onClick={() => filterData(l)}
            >
              <Typography fontSize={15} textTransform="capitalize">
                {l}
              </Typography>
              <Box
                position="absolute"
                bottom={-14}
                right={-14}
                height="55px"
                width="55px"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ backgroundColor: alpha(imageColors[Math.floor(Math.random() * 5)], 0.3) }}
              >
                <Image
                  src="https://cms.fainlearn.com/uploads/Vector_4473001369.svg"
                  sx={{
                    '& .wrapper': {
                      width: 'auto',
                      height: 'auto'
                    }
                  }}
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

DisplayCategory.propTypes = {
  title: PropTypes.string,
  list: PropTypes.array,
  filterData: PropTypes.func
};

export default function DiscoverCategory({ handleDisplayClasses }) {
  const categoryData = useSelector((state) => state.discover.categories);
  // dispatch
  const dispatch = useDispatch();

  const makeApiCall = async (search) => {
    capturePHEvents(PH_DISCOVER_CATEGORY_CLICK, { categoryName: search });
    const res = await searchClasses(search, API_LIMIT_DATA, 0, searchFilter);
    if (res) {
      dispatch({
        type: ADD_DISCOVER_DATA,
        payload: {
          data: res.hits,
          offset: 1
        }
      });
      handleDisplayClasses(search);
    }
  };

  return (
    <Box>
      {categoryData?.categories && (
        <DisplayCategory
          title="Category"
          list={categoryData?.categories}
          filterData={makeApiCall}
        />
      )}
      {categoryData?.subjects && (
        <DisplayCategory title="Subject" list={categoryData?.subjects} filterData={makeApiCall} />
      )}
    </Box>
  );
}

DiscoverCategory.propTypes = {
  handleDisplayClasses: PropTypes.func
};
